export { DetailsCard } from './DetailsCard';
